import { ReactNode } from 'react'

import { ThemeProps } from '@hhgtech/hhg-components'
// import PlusIcon from 'public/svg/plus.svg'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

export type Source = string

type Props = {
  size?: 'lg' | 'md' | 'sm'
  className?: string
  sources: Source
  heading?: ReactNode
  isMobile?: boolean
}

export const StyledAMPSources = styled.details`
  summary {
    position: relative;
    margin-bottom: 8px;
    color: ${(props: ThemeProps) => props.theme.colors.gray600};
    list-style: none;

    &::before {
      position: relative;
      top: 4px;
      display: inline-block;
      padding-right: 4px;
      color: red;
      content: url(/svg/plus.svg);
      transform-origin: center center;
      transition: ease-out 0.4s;
    }

    &::-webkit-details-marker {
      display: none;
    }
  }

  &[open] > summary::before {
    transform: rotate(45deg);
  }

  .ampsources__inner {
    padding: 1rem;
    background: ${(props: ThemeProps) => props.theme.colors.neutral50};
    border-radius: 6px;

    * {
      max-width: 100%;
    }

    a {
      display: inline-block;
      color: ${(props: ThemeProps) => props.theme.colors.primaryBase};
      font-weight: normal;
      text-decoration: none;
      word-break: break-word;
    }

    > p {
      display: grid;
      color: ${(props: ThemeProps) => props.theme.colors.gray600};
      line-height: 22px;
      word-break: break-word;
    }
    > p:not(:last-child) {
      margin-bottom: 1rem;
    }
  }
`

const SourcesAmp = ({ className, sources, heading }: Props) => {
  const { formatMessage: f } = useIntl()

  const ampSourceInformation = sources.replace(
    /(<iframe.*?>.*?<\/iframe>)/g,
    '',
  )

  return (
    <StyledAMPSources className={className}>
      <summary>{heading || f({ id: 'articlePage.sourceCount' })}</summary>
      <div
        className="ampsources__inner"
        dangerouslySetInnerHTML={{ __html: ampSourceInformation }}
      />
    </StyledAMPSources>
  )
}

export { SourcesAmp }
